export const LaborHearing = [
    { value: 'AIJ', label: 'AIJ' },
    { value: 'Conciliação', label: 'Conciliação' },
    { value: 'Instruções e Julgamento', label: 'Instruções e Julgamento' },
    { value: 'UNA', label: 'UNA' },
    { value: 'Outros', label: 'Outros' },
];